import { render, staticRenderFns } from "./GroupPositions.vue?vue&type=template&id=9f008fa2&scoped=true"
import script from "./GroupPositions.vue?vue&type=script&lang=js"
export * from "./GroupPositions.vue?vue&type=script&lang=js"
import style0 from "./GroupPositions.vue?vue&type=style&index=0&id=9f008fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f008fa2",
  null
  
)

export default component.exports